module.exports = __webpack_public_path__ + "img/aaadef5.jpg";